<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">ประเภทการลา</span>
      <v-scroll-x-transition>
        <div class="search-toolbar" v-show="!leaveTypeFormShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            class="search-field"
          ></v-text-field>
          <v-btn
            :disabled="!permissions.canCreate"
            class="add-btn"
            color="primary"
            @click="handleAddLeaveType"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มประเภทการลา
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="leaveTypes"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.is_male="{ item }">
        <v-icon small color="success" v-if="item.is_male">mdi-check</v-icon>
        <v-icon small color="red darken-3" v-else>mdi-close</v-icon>
      </template>
      <template v-slot:item.is_female="{ item }">
        <v-icon small color="success" v-if="item.is_female">mdi-check</v-icon>
        <v-icon small color="red darken-3" v-else>mdi-close</v-icon>
      </template>
      <template v-slot:item.is_include_days_off="{ item }">
        <span class="body-2">
          {{ item.is_include_days_off ? 'นับรวมวันหยุด' : 'ไม่นับรวมวันหยุด' }}
        </span>
      </template>
      <template v-slot:item.leave_type="{ item }">
        <v-icon small color="success" v-if="item.leave_type">
          mdi-check
        </v-icon>
        <v-icon small color="red darken-3" v-else>mdi-close</v-icon>
      </template>
    </v-data-table>
    <LeaveTypeForm
      :formShow="leaveTypeFormShow"
      :formAction="leaveTypeFormAction"
      :leaveType="leaveType"
      :leaveTypeInit="leaveTypeInit"
      @isLeaveTypeDataChange="handleLeaveTypeFormDataChange"
      @formActionCompleted="handleLeaveTypeFormActionCompleted"
      @onReset="handleLeaveTypeFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="leaveTypeFormShow && leaveTypeFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import LeaveTypeForm from '@/views/leave-type/LeaveTypeForm.vue'

export default {
  components: {
    LeaveTypeForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['leave_type_code'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      headers: [
        {
          text: 'รหัสประเภทการลา',
          align: 'start',
          class: 'text-no-wrap',
          value: 'leave_type_code',
          width: 140,
        },
        { text: 'ประเภทการลา', class: 'text-no-wrap', value: 'title_th' },
        {
          text: 'ประเภทการลา (อังกฤษ)',
          class: 'text-no-wrap',
          value: 'title_en',
        },
        {
          text: 'จำนวนวันลาสูงสุด',
          align: 'center',
          class: 'text-no-wrap',
          width: 130,
          value: 'day_limit',
        },
        {
          text: 'ผู้ชาย',
          align: 'center',
          class: 'text-no-wrap',
          value: 'is_male',
          width: 90,
          sortable: false,
        },
        {
          text: 'ผู้หญิง',
          align: 'center',
          class: 'text-no-wrap',
          value: 'is_female',
          width: 90,
          sortable: false,
        },
        {
          text: 'คำนวณวันลาตามอายุงาน',
          align: 'center',
          class: 'text-no-wrap',
          sortable: false,
          value: 'leave_type',
          width: 140,
        },
        {
          text: 'การนับวันลา',
          align: 'start',
          class: 'text-no-wrap',
          value: 'is_include_days_off',
          width: 135,
        },
      ],
      leaveTypeFormShow: false,
      leaveTypeFormAction: '',
      leaveType: {},
      leaveTypeInit: {},
      isLeaveTypeDataChange: false,
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    leaveTypes() {
      return this.$store.state.leaveType.leaveTypes
    },
    permissions() {
      return {
        canCreate: this.uiCtrl?.isEnable('btn:::leave_type:create') ?? true,
        canViewRow: this.uiCtrl?.isEnable('row:::leave_type:get') ?? true,
      }
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ประเภทการลา',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchLeaveTypes: 'leaveType/fetchLeaveTypes',
    }),
    classRowSelected(row) {
      if (this.leaveType.leave_type_uuid === row.leave_type_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (!this.permissions.canViewRow) {
        this.dialogForbidden = true
        return
      }

      if (this.leaveType.leave_type_uuid === row.leave_type_uuid) {
        this.leaveTypeFormShow = false
        this.leaveTypeFormAction = ''
        this.leaveType = {}
        this.leaveTypeInit = {}
      } else {
        this.leaveTypeFormShow = true
        this.leaveTypeFormAction = 'edit'
        this.leaveType = { ...row, leave_type: row.leave_type ? true : false }
        this.leaveTypeInit = {
          ...row,
          leave_type: row.leave_type ? true : false,
        }
      }
    },
    handleRowSelected(row) {
      if (this.isLeaveTypeDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddLeaveType() {
      this.leaveTypeFormShow = true
      this.leaveTypeFormAction = 'add'
      this.leaveType = {
        leave_type: null,
      }
      this.leaveTypeInit = {
        leave_type: null,
      }
    },
    handleLeaveTypeFormDataChange(value) {
      this.isLeaveTypeDataChange = value
    },
    handleLeaveTypeFormReset(formAction) {
      if (formAction === 'edit') this.leaveType = { ...this.leaveTypeInit }
    },
    handleLeaveTypeFormActionCompleted(formAction) {
      this.leaveType = {}
      this.leaveTypeInit = {}
      this.leaveTypeFormShow = false
      this.leaveTypeFormAction = ''
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
      }
      this.fetchLeaveTypes(payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.leaveTypeFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isLeaveTypeDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>

<style scoped>
.search-toolbar {
  display: flex;
}

.search-field {
  width: 200px;
  padding: 0 5px;
}

.add-btn {
  margin-top: 1px;
}
</style>
